import React, { Suspense } from 'react'

const DrawerCouponTips = React.lazy(() => {
  return import(
    `@/${process.env.template}/src/pages/ShopCart/components/CouponTips/drawerCouponTips`
  )
})

const useDrawerCouponTips = (sureFn: (code: string, priority: '1') => void) => {
  const [open, setOpen] = React.useState(false)
  const [content, setContent] = React.useState('')
  const [coupon, setCoupon] = React.useState('')

  return {
    /**
     * @description: 打开优惠冲突弹框
     * @param {string} html 显示内容的html片段，后端接口返回
     * @param {string} code coupon code
     * @return {*}
     */
    openDrawerCouponTips: (html: string, code: string) => {
      setContent(html)
      setOpen(true)
      setCoupon(code)
    },
    closeDrawerCouponTips: () => {
      setOpen(false)
      setContent('')
    },
    CouponTips: (
      <>
        <Suspense fallback={<div />}>
          <DrawerCouponTips
            coupon={coupon}
            open={open}
            setOpen={setOpen}
            contentHtml={content}
            sureFn={sureFn}
          />
        </Suspense>
      </>
    )
  }
}

export default useDrawerCouponTips
